<nb-card class="card" [ngStyle]="{'overflow-y': editar? 'auto' : 'hidden'}">
  <app-spinner *ngIf="showSpinnerFotos"></app-spinner>
  <div *ngIf="!showSpinnerFotos">
    <nb-card-header class="Header">
      <h3 class="Titulos">VIN: <span>{{data.vin}}</span> | Modelo: <span>{{data.modelo}}</span></h3>
    </nb-card-header>
    <nb-card-body class="row card-body" style="margin-top: -30px;">

      <div class="col-6 left">
        <!-- [gestures]="false" -->
        <!-- <gallery class="appGallery" id="basic-test"  thumbWidth=100 thumbPosition="left"
          [items]="items" [itemTemplate]="itemTemplate" ></gallery> -->

            <!-- GALERIA MAIN -->

              <div class="gallery-container">
                <!-- Miniaturas a la izquierda -->
                <div class="thumbnails vertical">
                  <img
                    *ngFor="let img of imageData; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen principal con contador y flechas -->
                      <div class="main-image-container">
                        <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>

                        <div class="main-image-with-nav" style="position: relative; display: inline-block;">
                          <button 
                            class="nav-btn prev"
                            (click)="prevImage()"
                            [disabled]="selectedIndex === 0"
                            title="Imagen anterior"
                            type="button"
                          >
                            &#10094;
                          </button>

                          <img
                            [src]="selectedImageData"
                            alt="Imagen principal"
                            (click)="openLightbox()"
                            style="display: block;"
                          >

                          <button 
                            class="nav-btn next"
                            (click)="nextImage()"
                            [disabled]="selectedIndex === imageData.length - 1"
                            title="Imagen siguiente"
                            type="button"
                          >
                            &#10095;
                          </button>
                        </div>
                      </div>


              </div>


            <!-- Lightbox -->
            <div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
              <div
                class="lightbox-content with-thumbs"
                (click)="$event.stopPropagation()"
                (wheel)="onWheel($event)"
              >
                <span class="close-btn" (click)="closeLightbox()">&times;</span>

                <!-- Miniaturas izquierda en lightbox -->
                <div class="thumbnails vertical lightbox-thumbs">
                  <img
                    *ngFor="let img of imageData; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen zoomable con flechas -->
                <div class="zoom-container-with-nav">
                
                  <div class="zoom-container">
                    <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>
                    <img
                      [src]="selectedImageData"
                      [style.transform]="'translate(' + currentX + 'px, ' + currentY + 'px) scale(' + zoom + ')'"
                      alt="Imagen ampliada"
                      class="zoom-image"
                      (mousedown)="onMouseDown($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseup)="onMouseUp()"
                      (mouseleave)="onMouseLeave()"
                      draggable="false"
                    />
                        <button class="nav-btn prev" (click)="prevImage()">&lt;</button>
                      <button class="nav-btn next" (click)="nextImage()">&gt;</button>
                  </div>
              
                </div>
              </div>
            </div>


          <!-- END GALERIA MAIN -->

        <div class="dropdown">
          <b><span>Condición Inspección: </span></b>
          <span class='ml-3'>{{data.condicionInspeccion}}</span>
        </div>

        <div class="dropdown">
          <b><span>Condición Unidad: </span></b>
          <span class='ml-3'>{{data.condicionUnidad}}</span>
        </div>

        <div class="dropdown">
          <b><span>Comentario Discrepancia: </span></b>
          <span class='ml-3'>{{data.comentarioDiscrepancia}}</span>
        </div>

      </div>

      <div class="col-6 right" style="margin-top: -5px">

        <div class="dropdown">
          <b><span>Area Componente: </span></b>
          <span class='ml-3'>{{data.areaComponente}}</span>
        </div>

        <div class="dropdown">
          <b><span>Averia: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.tipoAveria}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select" id="inputAveriaComponente"
            placeholder="" [style]="{'width':'90%','height': '30px'}" [options]="tipoAveria"
            [(ngModel)]="tipoAveriaSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->
          <nb-select *ngIf="editar" fullWidth
          placeholder=""
          [(ngModel)]="tipoAveriaSeleccionada"
          [disabled]="!editar"
          class="limited-selector dropdown-select"
          id="inputAveriaComponente"
          >
          <nb-option *ngFor="let opcion of tipoAveria" [value]="opcion.value">
            {{ opcion.label }}
          </nb-option>
        </nb-select>

        </div>

        <div class="dropdown">
          <b><span>Severidad: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.severidad}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select" id="inputSeveridadComponente"
            placeholder="" [style]="{'width':'90%','height': '30px'}" [options]="severidad"
            [(ngModel)]="SeveridadSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->
          <nb-select *ngIf="editar" fullWidth
            placeholder=""
            [(ngModel)]="SeveridadSeleccionada"
            [disabled]="!editar"
            class="limited-selector dropdown-select"
            id="inputSeveridadComponente"
          >
            <nb-option *ngFor="let opcion of severidad" [value]="opcion.value">
              {{ opcion.label }}
            </nb-option>
          </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Zona Cuadrante: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.zonaCuadranteDetalle}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select"
            id="inputZonaCuadranteDComponente" placeholder="" [style]="{'width':'90%','height': '30px'}"
            [options]="zonaCuadranteDetalle" [(ngModel)]="zonaCuadranteDetalleSeleccionada" [virtualScroll]="true"
            [itemSize]="31" [filter]="true">
          </p-dropdown> -->
          <nb-select *ngIf="editar" fullWidth
            placeholder=""
            [(ngModel)]="SeveridadSeleccionada"
            [disabled]="!editar"
            class="limited-selector dropdown-select"
            id="inputSeveridadComponente"
          >
            <nb-option *ngFor="let opcion of severidad" [value]="opcion.value">
              {{ opcion.label }}
            </nb-option>
          </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Clasificación: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.clasificacion}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select" id="inputClasificacionComponent"
            placeholder="" [style]="{'width':'90%','height': '30px'}" [options]="clasificacion"
            [(ngModel)]="clasificacionSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->
          <nb-select *ngIf="editar" fullWidth
            placeholder=""
            [(ngModel)]="clasificacionSeleccionada"
            [disabled]="!editar"
            class="limited-selector dropdown-select"
            id="inputClasificacionComponent"
          >
            <nb-option *ngFor="let opcion of clasificacion" [value]="opcion.value">
              {{ opcion.label }}
            </nb-option>
          </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Responsable: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.responsable}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select" id="inputResponsableComponente"
            placeholder="" [style]="{'width':'90%','height': '30px'}" [options]="responsables"
            [(ngModel)]="responsablesSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->

          <nb-select *ngIf="editar" fullWidth
            placeholder=""
            [(ngModel)]="responsablesSeleccionada"
            [disabled]="!editar"
            class="limited-selector dropdown-select"
            id="inputResponsableComponente"
          >
            <nb-option *ngFor="let opcion of responsables" [value]="opcion.value">
              {{ opcion.label }}
            </nb-option>
          </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Receptor: </span></b>
          <span class='ml-3'>{{data.receptor}}</span>
        </div>

        <div class="dropdown">
          <b><span>Cedente:</span></b>
          <span class='ml-3'>{{data.cedente}}</span>
        </div>

        <div class="dropdown">
          <b><span>Comentario de Edición: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{data.comentarioModificacion}}</span>
          <textarea *ngIf="editar" [(ngModel)]="comentarioAveria" [ngStyle]="styleTextArea()"></textarea>
        </div>

      </div>

      <div *ngIf="!showSpinnerGuardar" class="btnsGuardar">
        <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>

        <div *ngIf="!showSpinnerGuardar" class="btnsGuardar" style="position: relative;">

          <span class="faltaComentario" *ngIf="isComentarioEdicion === false">
            Debe agregar un comentario
          </span>
          
          <!-- (click)="lightbox.open(0, 'lightbox', {panelClass: 'fullscreen'})" -->
          <button nbButton size="small" class="buttontz float-left reporteBTN"
            (click)="openLightbox()">
            <nb-icon nbPrefix icon="expand-outline"></nb-icon>
          </button>

          <button *ngIf="data.solucionada && usersRol.EDITAR_AVERIAS_DISCREPANCIA" nbButton size="small"
            class="float-left buttontz reporteBTN" (click)="!editar ? habilitarEdicion() : deshabilitarEdicion()"
            [disabled]="!cargo">
            <span *ngIf="!editar">Editar</span>
            <nb-icon *ngIf="editar" nbPrefix icon="close-outline"></nb-icon>
          </button>

          <button *ngIf="data.solucionada && usersRol.EDITAR_AVERIAS_DISCREPANCIA && editar" nbButton size="small"
            class="buttontz reporteBTN" [disabled]="!habilitarGuardarCambios" (click)="saveEdicionYSolucionar()">
            Guardar y Solucionar
          </button>

          <button *ngIf="data.solucionada && !editar" nbButton size="small" class="buttontz reporteBTN"
            [disabled]="deshabilitarSolucionar" (click)="open()">
            Solucionar (Original)
          </button>

          <button nbButton size="small" class="buttontz reporteBTN" (click)="close()">
            Cancelar
          </button>
        </div>
      </div>

    </nb-card-body>
  </div>
</nb-card>

<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <!-- <gallery [src]="[data.src]" [config]="myConfig"></gallery> -->
  </ng-container>
</ng-template>